/**
 * Maps Warbler settings URLs to Atlas Setup URLs.
 * Used by VerticalMenuBar to rewrite menu links when settingsVersion === 'atlas'.
 */
export const ATLAS_SETTINGS_LINKS: Record<string, string> = {
  '/settings/contact': '/assistant/setup/store-contact',
  '/settings/reorder-parameters': '/assistant/setup/variants',
  '/settings/incoming-inventory': '/assistant/setup/incoming',
  '/settings/inventory-forecast': '/assistant/setup/forecasting',
  '/settings/bundle-product-mapping': '/assistant/setup/bundles',
  '/settings/multi-store-settings': '/assistant/setup/multistore',
  '/settings/location-restrictions': '/assistant/setup/locations',
  '/settings/purchase-order': '/assistant/setup/po-tax',
  '/settings/internal-inventory-transfer-settings': '/assistant/setup/transfers',
  '/suppliers': '/assistant/setup/suppliers',
};

/**
 * localStorage key for settings version preference.
 */
export const SETTINGS_VERSION_KEY = 'settingsVersion';

/**
 * Returns true if the user has opted into Atlas Setup.
 */
export function isAtlasSettingsEnabled(): boolean {
  return localStorage.getItem(SETTINGS_VERSION_KEY) === 'atlas';
}

/**
 * Sets the settings version preference.
 */
export function setSettingsVersion(version: 'classic' | 'atlas'): void {
  localStorage.setItem(SETTINGS_VERSION_KEY, version);
}
